import { render, staticRenderFns } from "./MedicineClassEdit.vue?vue&type=template&id=4ef2a300&scoped=true&"
import script from "./MedicineClassEdit.vue?vue&type=script&lang=js&"
export * from "./MedicineClassEdit.vue?vue&type=script&lang=js&"
import style0 from "./MedicineClassEdit.vue?vue&type=style&index=0&id=4ef2a300&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef2a300",
  null
  
)

export default component.exports